import styled from "styled-components";

import { outlineActiveElement } from "ui/styles/style-snippets";

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 24px;
  width: 24px;
  border: none;
  background-color: transparent;
  color: ${(p) => p.theme.textMediumContrast};
  cursor: pointer;

  &:focus-visible {
    ${outlineActiveElement}
  }
  &:disabled {
    color: ${(p) => p.theme.textLowestContrast};
    cursor: not-allowed;
  }
  svg {
    width: 20px;
    height: auto;
  }
`;
